<template>
  <el-descriptions class="rc-desc" v-bind="$attrs">
    <el-descriptions-item
      v-for="(item, index) in data"
      v-bind="item"
      :key="item.label || index"
    >
      <template v-for="si in slots.item" :slot="si">
        <slot :name="si" :row="item" :index="index">
          <template v-if="si === 'default'">
            <el-tag v-if="item.tag" v-bind="item.tag">{{text(item)}}</el-tag>
            <template v-else>{{text(item)}}</template>
          </template>
          <template v-else>
            {{item.aliasLabel || item.label}}
          </template>
        </slot>
      </template>
    </el-descriptions-item>
    <template v-for="si in slots.desc" :slot="si">
      <slot :name="si" :row="$attrs.data"></slot>
    </template>
  </el-descriptions>
</template>

<script>
export default {
  name: "RcDesc",
  props: {
    data: {
      type: Array,
      default: () => ([])
    },
    model: {
      type: Object,
      default: () => ({})
    },
    slots: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    text() {
      return item => this.model[item.prop] || item.text;
    }
  }
};
</script>

<style lang="scss" scoped>
.rc-desc{
  margin: 0;
  ::v-deep .el-descriptions-row {
    height: auto;
  }
  ::v-deep .el-descriptions-item__cell {
    padding-bottom: 0;
    padding-top: 4px;
  }
}
</style>
